import React from 'react';
import { Stack } from '@mui/material';
import { IContract } from '../../../../../../types/contract';
import { ContractExtractionResult } from '../../../../../../types/aiOutput';
import { DialogMode } from '../../../../../../types/dialogmode';
import { IDocument } from '../../../../../../types/document';
import VendorSection from '../../VendorSection';

interface VendorTabProps {
  contract: IContract;
  aiOutputs: ContractExtractionResult[];
  documents: IDocument[];
  mode: DialogMode;
}

const VendorTab: React.FC<VendorTabProps> = ({
  contract,
  aiOutputs,
  documents,
  mode,
}) => {
  return (
    <Stack>
      <VendorSection
        contract={contract}
        aiOutputs={aiOutputs}
        documents={documents}
        mode={mode}
      />
    </Stack>
  );
};

export default VendorTab;
